module.exports = __webpack_public_path__ + "media/review-badges/rank-15k-e9af1d6c.svg";